import { PlusCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Button, notification, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IFeeKindLookupListTableRow } from '../../../../../interfaces/lookup/feeKind';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { NOTIFICATION_PLACEMENT } from '../../../../../shared/Constants';
import { AppDispatch, RootState } from '../../../../../store';
import { fetchKindOfFees } from '../../../../../store/lookupSlice/LookupActions';
import { resetState } from '../../../../../store/lookupSlice/LookupSlice';

export const KindOfFeeLookupListOverview = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { kindOfFees } = useSelector((state: RootState) => state.lookupSlice);

    const columns: ColumnsType<IFeeKindLookupListTableRow> = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            render: (_, record) => (
                <>
                    <Tooltip title={record.description}>{record.code}</Tooltip>
                </>
            ),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Space size="middle">
                    <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/admin/lookup-lists/kind-of-fee/${record.id}`)} />
                </Space>
            ),
        },
    ];

    useEffect(() => {
        if (kindOfFees.model.updateStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/kind-of-fee', { replace: true });
        }
    }, [kindOfFees.model.updateStatus]);

    useEffect(() => {
        dispatch(fetchKindOfFees());

        return () => {
            dispatch(resetState());
        };
    }, []);

    useEffect(() => {
        if (kindOfFees.model.fetchStatus === StatePieceStatus.Error) {
            notification.error({
                message: 'An error occurred.',
                duration: 0,
                description: 'An error occurred while retrieving the data. Please contact your administrator if the problem persists.',
                placement: NOTIFICATION_PLACEMENT,
            });
        }
    }, [kindOfFees.model.fetchStatus]);

    return (
        <div className="app-page">
            <ContentHeader
                title="Manage Kind of fees lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Kind of fees',
                        path: '/admin/lookup-lists/kind-of-fee',
                    },
                ]}
            >
                <>
                    <Button type="primary" icon={<PlusCircleOutlined />} onClick={() => navigate('/admin/lookup-lists/kind-of-fee/add')}>
                        Add new option
                    </Button>
                </>
            </ContentHeader>

            <div className="page-content">
                <Table
                    size="small"
                    bordered={true}
                    loading={kindOfFees.model.fetchStatus === StatePieceStatus.IsFetching}
                    dataSource={kindOfFees.model.data.map((option, i) => {
                        return { ...option, key: i } as IFeeKindLookupListTableRow;
                    })}
                    columns={columns}
                    pagination={{
                        defaultPageSize: 50,
                    }}
                />
            </div>
        </div>
    );
};
